import { ProgressCircleIcon } from '@/components/icons/progressCircle'
import { cn } from '@/utils/cn'
import { formatTokenValue } from '@vaultsfyi/common/utils'
import { Tooltip, TooltipContent, type TooltipProps } from './tooltip'

interface CapacityTooltipProps {
  maxCapacity: string
  remainingCapacity: string
  assetSymbol: string
  assetDecimals: number
}

type Props = CapacityTooltipProps & Pick<TooltipProps, 'className' | 'tabIndex'>

export const CapacityTooltip = ({
  maxCapacity,
  remainingCapacity,
  assetSymbol,
  assetDecimals,
  className,
  tabIndex,
}: Props) => {
  const maxCapacityBig = BigInt(maxCapacity)
  if (maxCapacityBig === 0n) return null

  const fillPercent = Number(((maxCapacityBig - BigInt(remainingCapacity)) * 100n) / maxCapacityBig)

  if (fillPercent < 80) return null

  return (
    <Tooltip
      tabIndex={tabIndex}
      className={cn(
        'relative z-[1] flex min-h-6 w-fit min-w-6 items-center justify-center rounded-full border border-transparent bg-transparent',
        'hocus:border-border hocus:bg-surface',
        className
      )}
    >
      <ProgressCircleIcon progress={fillPercent} size={24} className={'text-accent'} />
      <TooltipContent side="top" align="start">
        <p className="font-semibold">Vault is filled at ~{fillPercent}%</p>
        <p>
          {formatTokenValue({ value: remainingCapacity, decimals: assetDecimals })} {assetSymbol} remaining
        </p>
      </TooltipContent>
    </Tooltip>
  )
}
